<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      redirect_link: "",
      linkovi: [
        { naziv: "prezentacija", link: "https://drive.google.com/file/d/1SHu_N1zeyc_pDF2jD63yHlddjcbdg4fR/view" },
        { naziv: "upute-za-izradu-video-lekcija", link: "https://drive.google.com/file/d/1i_pNjbUJFwhhcKKl8VewXh6vt2MpGHwt/view?usp=sharing" },
        { naziv: "google-classroom-upute", link: "https://drive.google.com/file/d/1T1BRcB_IBiWjOG6tAKD8zrMAIX9XG57_/view" }
      ]
    };
  },
  created() {
    this.redirect_link = this.linkovi.find(item => {
      return item.naziv == this.$route.params.alias;
    });
    window.location.href = this.redirect_link.link;
  }
};
</script>